<div *ngIf="global_texts" class="all-content">
  <div class="">
    <app-header></app-header>
  </div>
  <div class="content">
    <div class="inner-content">

      <div class="sidebar-content">
        <app-sidebar></app-sidebar>
      </div>

      <div class="p-3 p-lg-5">
        <div class="bubble-step py-5 mb-5 d-flex flex-column flex-sm-row">

          <div class="pe-sm-3 pe-xl-5 pb-5 pb-sm-0">
            <img width="350" alt="chess" src="/assets/images/chess_panel.svg"/>
          </div>

          <div>
            <h1 class="text-bubble-step fw-bold text-start" [innerHtml]="page_texts.title"></h1>
            <h5 class="mt-3 text-start" [innerHtml]="page_texts.text_info"></h5>
            <h5 class="mt-3 text-start" [innerHtml]="page_texts.text_info_2"></h5>

            <div class="bloc-buttons mt-5">
              <div *ngFor="let mod of modules" class="">
                <a role="button" class="d-flex align-items-center btn btn-lined-green mb-3"
                   [attr.data-text]="mod.module_title" [ngClass]="app.sharedHelper.getStatusClass(mod.module_status)"
                   (click)="app.sharedHelper.startOrContinueModule(mod.module_uuid)">
                  <!-- Old code : app.sharedHelper.goToFirtScreen(mod.module_uuid) -->
                  <svg class="me-3" *ngIf="mod.module_icon">
                    <use [attr.xlink:href]="'#' + mod.module_icon"></use>
                  </svg>
                  <span class="flex-fill" [class.text-start]="mod.module_icon" [innerHtml]="mod.module_title"></span>
                </a>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>


    <div>
      <app-footer></app-footer>
    </div>
  </div>

  <button class="fixed-reset-button" (click)="cookieConsentHelper.resetCookies()">
    <span [innerHtml]="global_texts.reset_cookies"></span>
  </button>
</div>
